import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Haendler } from '../haendler';
import { HaendlerDetailsComponent } from '../haendler-details/haendler-details.component';

@Component({
    selector: 'kiene-haendler-details-dialog',
    templateUrl: './haendler-details-dialog.component.html',
    styleUrls: ['./haendler-details-dialog.component.scss'],
})
export class HaendlerDetailsDialogComponent implements OnInit {
    haendler: Haendler;
    @ViewChild('haendlerDetailsComp') haendlerDetailsComp?: HaendlerDetailsComponent;
    constructor(
        public dialogRef: MatDialogRef<HaendlerDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data?.haendler) {
            this.haendler = data.haendler;
        } else {
            this.haendler = new Haendler();
        }
    }

    ngOnInit(): void {}

    onDialogContentScroll(): void {
        this.haendlerDetailsComp?.closeAutocompletePanel();
    }

    save(): void {
        this.haendlerDetailsComp?.addOrUpdateHaendler();
    }
}
